var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "tab-vessel-eq" },
        [
          _c(
            "tab-vessel-eq-UICustom-layout",
            { attrs: { "element-blocks": _vm.elementBlocks } },
            [
              _vm.elementDict.voyageFlight.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "voyageFlight" },
                      slot: "voyageFlight"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.voyageFlight.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.voyageFlight.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { no: "6", disabled: "" },
                        model: {
                          value: _vm.form.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "voyageFlight", $$v)
                          },
                          expression: "form.voyageFlight"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mbl.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "mbl" }, slot: "mbl" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.mbl.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "padding-right": "3px"
                          }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isInputMbl,
                                expression: "isInputMbl"
                              }
                            ],
                            class:
                              _vm.form.mbl === "CANCELLED" ? "mbl-red" : "",
                            attrs: { no: "7", disabled: "" },
                            model: {
                              value: _vm.form.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mbl", $$v)
                              },
                              expression: "form.mbl"
                            }
                          }),
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isInputMbl,
                                expression: "!isInputMbl"
                              }
                            ],
                            class:
                              _vm.form.mbl === "CANCELLED" ? "mbl-red" : "",
                            attrs: { no: "8", disabled: "" },
                            on: {
                              input: function($event) {
                                _vm.mblConfig.curRule = null
                              }
                            },
                            model: {
                              value: _vm.form.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mbl", $$v)
                              },
                              expression: "form.mbl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.jobSoNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "jobSoNo" }, slot: "jobSoNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.jobSoNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.jobSoNo.label
                        },
                        slot: "label"
                      }),
                      _c("so-no-input", {
                        attrs: {
                          no: "27",
                          disabled:
                            !_vm.isEdit || !_vm.elementDict.jobSoNo.writable
                        },
                        model: {
                          value: _vm.form.jobSoNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "jobSoNo", $$v)
                          },
                          expression: "form.jobSoNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "bookingDate" },
                      slot: "bookingDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "bookingDate",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "bookingDate",
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.bookingDate.writable,
                          type: "date",
                          clearable: "",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "bookingDate",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.bookingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bookingDate", $$v)
                          },
                          expression: "form.bookingDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingNo" }, slot: "bookingNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            !_vm.isEdit || !_vm.elementDict.bookingNo.writable,
                          no: "9"
                        },
                        model: {
                          value: _vm.form.bookingNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bookingNo", $$v)
                          },
                          expression: "form.bookingNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quotationNum.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "quotationNum" }, slot: "quotationNum" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quotationNum.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quotationNum.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.quotationNum.writable,
                          no: "12"
                        },
                        model: {
                          value: _vm.form.quotationNum,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quotationNum", $$v)
                          },
                          expression: "form.quotationNum"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.airport.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "airport" }, slot: "airport" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.airport.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.airport.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "19",
                          disabled:
                            !_vm.isEdit ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.airport.writable
                        },
                        model: {
                          value: _vm.form.airport,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "airport", $$v)
                          },
                          expression: "form.airport"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualEntryTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualEntryTime" },
                      slot: "actualEntryTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualEntryTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualEntryTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "actualEntryTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "20",
                          disabled:
                            !_vm.isEdit ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualEntryTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "actualEntryTime",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.actualEntryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualEntryTime", $$v)
                          },
                          expression: "form.actualEntryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualLoadingTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualLoadingTime" },
                      slot: "actualLoadingTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualLoadingTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualLoadingTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "actualLoadingTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "21",
                          disabled:
                            !_vm.isEdit ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualLoadingTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "actualLoadingTime",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.actualLoadingTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualLoadingTime", $$v)
                          },
                          expression: "form.actualLoadingTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedDepartureTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedDepartureTime" },
                      slot: "estimatedDepartureTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedDepartureTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.estimatedDepartureTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "estimatedDepartureTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "22",
                          disabled:
                            !_vm.isEdit ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedDepartureTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "estimatedDepartureTime",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.estimatedDepartureTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estimatedDepartureTime", $$v)
                          },
                          expression: "form.estimatedDepartureTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualDepartureTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualDepartureTime" },
                      slot: "actualDepartureTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualDepartureTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualDepartureTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "actualDepartureTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "23",
                          disabled:
                            !_vm.isEdit ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualDepartureTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "actualDepartureTime",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.actualDepartureTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualDepartureTime", $$v)
                          },
                          expression: "form.actualDepartureTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.estimatedArrivalTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.estimatedArrivalTime.viewable && showButton"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "estimatedArrivalTime" },
                  slot: "estimatedArrivalTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedArrivalTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedArrivalTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "estimatedArrivalTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "estimatedPortDischargeTime",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.estimatedArrivalTime.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "estimatedArrivalTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.estimatedArrivalTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "estimatedArrivalTime", $$v)
                      },
                      expression: "form.estimatedArrivalTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualArrivalTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.actualArrivalTime.viewable && showButton"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "actualArrivalTime" },
                  slot: "actualArrivalTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualArrivalTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualArrivalTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualArrivalTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "34",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.actualArrivalTime.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualArrivalTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualArrivalTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualArrivalTime", $$v)
                      },
                      expression: "form.actualArrivalTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualReceivingTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.actualReceivingTime.viewable && showButton"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "actualReceivingTime" },
                  slot: "actualReceivingTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualReceivingTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualReceivingTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualReceivingTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "actualReceivingTime",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.actualReceivingTime.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualReceivingTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualReceivingTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualReceivingTime", $$v)
                      },
                      expression: "form.actualReceivingTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualUnloadingTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.actualUnloadingTime.viewable && showButton"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "actualUnloadingTime" },
                  slot: "actualUnloadingTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualUnloadingTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualUnloadingTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualUnloadingTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "35",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.actualUnloadingTime.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualUnloadingTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualUnloadingTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualUnloadingTime", $$v)
                      },
                      expression: "form.actualUnloadingTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualArrivalNotificationTime
                          .viewable && _vm.showButton,
                      expression:
                        "elementDict.actualArrivalNotificationTime.viewable && showButton"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "actualArrivalNotificationTime" },
                  slot: "actualArrivalNotificationTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualArrivalNotificationTime
                      .isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualArrivalNotificationTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualArrivalNotificationTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "actualArrivalNotificationTime",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.actualArrivalNotificationTime.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualArrivalNotificationTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualArrivalNotificationTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualArrivalNotificationTime", $$v)
                      },
                      expression: "form.actualArrivalNotificationTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualPickupTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.actualPickupTime.viewable && showButton"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "actualPickupTime" },
                  slot: "actualPickupTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualPickupTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualPickupTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualPickupTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "36",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.actualPickupTime.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualPickupTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualPickupTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualPickupTime", $$v)
                      },
                      expression: "form.actualPickupTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.estimatedWarehouseDeliveryTime
                          .viewable && _vm.showButton,
                      expression:
                        "elementDict.estimatedWarehouseDeliveryTime.viewable && showButton"
                    }
                  ],
                  attrs: {
                    slot: "estimatedWarehouseDeliveryTime",
                    title: _vm.elementDict.estimatedWarehouseDeliveryTime.label
                  },
                  slot: "estimatedWarehouseDeliveryTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedWarehouseDeliveryTime
                      .isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.estimatedWarehouseDeliveryTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "estimatedWarehouseDeliveryTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        !_vm.isEdit ||
                        !_vm.elementDict.estimatedWarehouseDeliveryTime
                          .writable,
                      no: "41",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "estimatedWarehouseDeliveryTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.estimatedWarehouseDeliveryTime,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "estimatedWarehouseDeliveryTime",
                          $$v
                        )
                      },
                      expression: "form.estimatedWarehouseDeliveryTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualWarehouseDeliveryTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.actualWarehouseDeliveryTime.viewable && showButton"
                    }
                  ],
                  attrs: {
                    slot: "actualWarehouseDeliveryTime",
                    title: _vm.elementDict.actualWarehouseDeliveryTime.label
                  },
                  slot: "actualWarehouseDeliveryTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualWarehouseDeliveryTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualWarehouseDeliveryTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualWarehouseDeliveryTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        !_vm.isEdit ||
                        !_vm.elementDict.actualWarehouseDeliveryTime.writable,
                      no: "42",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualWarehouseDeliveryTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualWarehouseDeliveryTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualWarehouseDeliveryTime", $$v)
                      },
                      expression: "form.actualWarehouseDeliveryTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.estimatedShippingTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.estimatedShippingTime.viewable && showButton"
                    }
                  ],
                  attrs: {
                    slot: "estimatedShippingTime",
                    title: _vm.elementDict.estimatedShippingTime.label
                  },
                  slot: "estimatedShippingTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedShippingTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedShippingTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "estimatedShippingTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        !_vm.isEdit ||
                        !_vm.elementDict.estimatedShippingTime.writable,
                      no: "43",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "estimatedShippingTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.estimatedShippingTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "estimatedShippingTime", $$v)
                      },
                      expression: "form.estimatedShippingTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.actualShippingTime.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.actualShippingTime.viewable && showButton"
                    }
                  ],
                  attrs: {
                    slot: "actualShippingTime",
                    title: _vm.elementDict.actualShippingTime.label
                  },
                  slot: "actualShippingTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.actualShippingTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.actualShippingTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "actualShippingTime",
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        !_vm.isEdit ||
                        !_vm.elementDict.actualShippingTime.writable,
                      no: "44",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "actualShippingTime",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.actualShippingTime,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "actualShippingTime", $$v)
                      },
                      expression: "form.actualShippingTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.estimatedTimeOfDelivery.viewable &&
                        _vm.showButton,
                      expression:
                        "elementDict.estimatedTimeOfDelivery.viewable && showButton"
                    }
                  ],
                  attrs: { slot: "estimatedTimeOfDelivery" },
                  slot: "estimatedTimeOfDelivery"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedTimeOfDelivery.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedTimeOfDelivery.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    ref: "estimatedTimeOfDelivery",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "32",
                      type: "datetime",
                      disabled:
                        !_vm.isEdit ||
                        Boolean(_vm.form.lclMasterUuid) ||
                        !_vm.elementDict.estimatedTimeOfDelivery.writable,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "estimatedTimeOfDelivery",
                          null,
                          true,
                          true,
                          _vm.form
                        )
                      }
                    },
                    model: {
                      value: _vm.form.estimatedTimeOfDelivery,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "estimatedTimeOfDelivery", $$v)
                      },
                      expression: "form.estimatedTimeOfDelivery"
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.actualDeliveryTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "actualDeliveryTime" },
                      slot: "actualDeliveryTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualDeliveryTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualDeliveryTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "actualDeliveryTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "33",
                          type: "datetime",
                          disabled:
                            !_vm.isEdit ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualDeliveryTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "actualDeliveryTime",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.actualDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualDeliveryTime", $$v)
                          },
                          expression: "form.actualDeliveryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.shippingAddress.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "shippingAddress" },
                      slot: "shippingAddress"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.shippingAddress.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.shippingAddress.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.shippingAddress.writable,
                          type: "textarea",
                          rows: 3,
                          no: "49"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.shippingAddress.label,
                              _vm.form.shippingAddress,
                              function(val) {
                                _vm.form.shippingAddress = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.shippingAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shippingAddress", $$v)
                          },
                          expression: "form.shippingAddress"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.shippingContactPerson.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "shippingContactPerson" },
                      slot: "shippingContactPerson"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.shippingContactPerson.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.shippingContactPerson.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.shippingContactPerson.writable,
                          no: "50"
                        },
                        model: {
                          value: _vm.form.shippingContactPerson,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shippingContactPerson", $$v)
                          },
                          expression: "form.shippingContactPerson"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.shippingContactInfo.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "shippingContactInfo" },
                      slot: "shippingContactInfo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.shippingContactInfo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.shippingContactInfo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.shippingContactInfo.writable,
                          no: "51"
                        },
                        model: {
                          value: _vm.form.shippingContactInfo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shippingContactInfo", $$v)
                          },
                          expression: "form.shippingContactInfo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.fileCutoff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "fileCutoff" }, slot: "fileCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.fileCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.fileCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "fileCutoff",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit || !_vm.elementDict.fileCutoff.writable,
                          no: "52",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "fileCutoff",
                              null,
                              true,
                              true,
                              _vm.form
                            )
                          }
                        },
                        model: {
                          value: _vm.form.fileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fileCutoff", $$v)
                          },
                          expression: "form.fileCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerFileCutoff.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerFileCutoff" },
                      slot: "customerFileCutoff"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerFileCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerFileCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.customerFileCutoff.writable,
                          no: "56",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.customerFileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerFileCutoff", $$v)
                          },
                          expression: "form.customerFileCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customCutoff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customCutoff" }, slot: "customCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.customCutoff.writable,
                          no: "54",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.customCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customCutoff", $$v)
                          },
                          expression: "form.customCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerCutoff.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerCutoff" },
                      slot: "customerCutoff"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.customerCutoff.writable,
                          no: "55",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.customerCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerCutoff", $$v)
                          },
                          expression: "form.customerCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerShutout.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerShutout" },
                      slot: "customerShutout"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerShutout.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerShutout.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.customerShutout.writable,
                          no: "56",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.customerShutout,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerShutout", $$v)
                          },
                          expression: "form.customerShutout"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondFlight.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondFlight" },
                      slot: "secondFlight"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondFlight.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondFlight.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: "", no: "64" },
                        model: {
                          value: _vm.form.secondFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondFlight", $$v)
                          },
                          expression: "form.secondFlight"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.secondPolCode.viewable,
                      expression: "elementDict.secondPolCode.viewable"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "secondPolCode" },
                  slot: "secondPolCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondPolCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondPolCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondPolCode",
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "secondPolCode",
                      "select-type": _vm.selectTypeNames.basic_data_Airport,
                      disabled:
                        !_vm.isEdit || !_vm.elementDict.secondPolCode.writable,
                      filterable: "",
                      "default-value": _vm.form.secondPolCode,
                      "tag-name": "code"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.secondPolCode = p.value
                        _vm.form.secondPol = p.englishName
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.secondPol.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondPol" },
                      slot: "secondPol"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondPol.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondPol.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            !_vm.isEdit || !_vm.elementDict.secondPol.writable,
                          no: "secondPol"
                        },
                        model: {
                          value: _vm.form.secondPol,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondPol", $$v)
                          },
                          expression: "form.secondPol"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.secondPodCode.viewable,
                      expression: "elementDict.secondPodCode.viewable"
                    }
                  ],
                  staticClass: "warn-label",
                  attrs: { slot: "secondPodCode" },
                  slot: "secondPodCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondPodCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondPodCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondPodCode",
                    staticStyle: { flex: "1" },
                    attrs: {
                      disabled:
                        !_vm.isEdit || !_vm.elementDict.secondPodCode.writable,
                      no: "secondPodCode",
                      "select-type": _vm.selectTypeNames.basic_data_Airport,
                      filterable: "",
                      "default-value": _vm.form.secondPodCode,
                      "tag-name": "code"
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.secondPod.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondPod" },
                      slot: "secondPod"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondPod.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondPod.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: "", no: "secondPod" },
                        model: {
                          value: _vm.form.secondPod,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondPod", $$v)
                          },
                          expression: "form.secondPod"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedTransferArrivalTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedTransferArrivalTime" },
                      slot: "estimatedTransferArrivalTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedTransferArrivalTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedTransferArrivalTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.estimatedTransferArrivalTime
                              .writable,
                          no: "estimatedTransferArrivalTime",
                          type: "date",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.estimatedTransferArrivalTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedTransferArrivalTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedTransferArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transferArrivalTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "transferArrivalTime" },
                      slot: "transferArrivalTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transferArrivalTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transferArrivalTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.transferArrivalTime.writable,
                          no: "transferArrivalTime",
                          type: "date",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.transferArrivalTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "transferArrivalTime", $$v)
                          },
                          expression: "form.transferArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedTransferDepartureTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedTransferDepartureTime" },
                      slot: "estimatedTransferDepartureTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedTransferDepartureTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedTransferDepartureTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.estimatedTransferDepartureTime
                              .writable,
                          no: "estimatedTransferDepartureTime",
                          type: "date",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.estimatedTransferDepartureTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedTransferDepartureTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedTransferDepartureTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transferDepartureTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "transferDepartureTime" },
                      slot: "transferDepartureTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transferDepartureTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transferDepartureTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.transferDepartureTime.writable,
                          no: "transferDepartureTime",
                          type: "date",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.form.transferDepartureTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "transferDepartureTime", $$v)
                          },
                          expression: "form.transferDepartureTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.multiJourneyAirline &&
              _vm.elementDict.multiJourneyAirline.viewable
                ? _c(
                    "template",
                    { slot: "multiJourneyAirline" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          staticStyle: {
                            float: "right",
                            "margin-bottom": "5px"
                          },
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.addAirline }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                      ),
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.columnDefs,
                          "row-data": _vm.rowData,
                          "show-side-bar": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c("generate-mbl-no-dialog", {
            attrs: {
              visible: _vm.mblConfig.visible,
              form: _vm.form,
              config: _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.mblConfig.visible = false
              }
            }
          }),
          _c("generate-so-no-dialog", {
            attrs: {
              visible: _vm.soNoConfig.visible,
              form: _vm.form,
              config: _vm.soNoConfig,
              "mbl-config": _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.soNoConfig.visible = false
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: "10" },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }